var map = {
	"./abrigos-y-gabardinas.jpg": "39f3",
	"./ajusta.jpg": "dbdd",
	"./alta-costura.jpg": "4605",
	"./arreglos-de-disfraces.jpg": "a67a",
	"./banadores-y-lenceria.jpg": "1930",
	"./bgservicios.jpg": "3182",
	"./bgserviciosmobile-v2.jpg": "0e54",
	"./bgserviciosmobile.jpg": "56e6",
	"./bordados.jpg": "d497",
	"./camisas-y-blusas.jpg": "da36",
	"./chamarras.jpg": "9bcf",
	"./cortinas-y-ropa-de-cama.jpg": "5b2c",
	"./crea.jpg": "d523",
	"./etiquetas.jpg": "b12c",
	"./faldas.jpg": "38c0",
	"./modificacion-y-transformacion-de-prendas.jpg": "f3c1",
	"./pantalones-y-shorts.jpg": "6e90",
	"./personaliza.jpg": "758b",
	"./planchado.jpg": "869f",
	"./repara.jpg": "9540",
	"./sacos-y-blazers.jpg": "be8a",
	"./vestidos.jpg": "66ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60b1";